import { render, staticRenderFns } from "./TheHomeAddResearchSpace.vue?vue&type=template&id=6a86d38d&"
import script from "./TheHomeAddResearchSpace.vue?vue&type=script&lang=js&"
export * from "./TheHomeAddResearchSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports